// extracted by mini-css-extract-plugin
export default {"input":"ReadingInput_input__Kd6We","prevReadings":"ReadingInput_prevReadings__ij8z4"};